module.exports = __webpack_public_path__ + "media/01.4007f2bd.mp4";